import { render, staticRenderFns } from "./TrainingQuiz.vue?vue&type=template&id=9d765288&"
import script from "./TrainingQuiz.vue?vue&type=script&lang=js&"
export * from "./TrainingQuiz.vue?vue&type=script&lang=js&"
import style0 from "./TrainingQuiz.vue?vue&type=style&index=0&id=9d765288&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports